import * as yup from "yup";

const updateEnvelopeStatusSchema = yup.object({
  revId: yup.mixed().label("Rev ID").required()
    .test(
      "type",
      "Rev ID must be a string or number",
      value => typeof value === "string" || typeof value === "number"
    ),
  status: yup.string().label("Status").required(),
  reason: yup
    .string()
    .label("Reason")
    .min(10, "Reason must be minimum 10 characters")
    .required(),
});

// validation structure is different compared to backend API
const retryFailedEnvelopeSchema = yup.object({
  id: yup.mixed().label("Rev ID").required()
    .test(
      "type",
      "Rev ID must be a string or number",
      value => typeof value === "string" || typeof value === "number"
    ),
  status: yup.string().label("Status").required(),
});

const triggerEnvelopeSchema = yup.object({
  hmg: yup.string().label("Hotel Management Group").required(),
  project: yup.string().label("Project").required(),
  hotel: yup.string().label("Hotel").required(),
  businessDate: yup
    .mixed()
    .label("Business Date")
    .required("Business Date required"),
  backDays: yup.number().label("Back Days").integer().min(0).nullable(),
  skipCheck: yup.boolean().label("Skip mandatory report check"),
});

export {
  updateEnvelopeStatusSchema,
  retryFailedEnvelopeSchema,
  triggerEnvelopeSchema,
};
